import React from "react";
import {
    Box,
    Typography,
    RadioGroup,
    FormControlLabel,
    Radio,
    Stack,
    Paper,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import Images from "../../../assets";

const paymentMethods = [
    // {
    //     value: "cod",
    //     label: "Αντικαταβολή",
    //     extra: "(+ €2.00)",
    //     cardBrands: [],
    // },
    {
        value: "bank_transfer",
        label: "Κατάθεση σε Τράπεζα",
        extra: null,
        cardBrands: [],
    },
    {
        value: "card",
        label: "Πιστωτική/Χρεωστική κάρτα/Iris",
        extra: null,
        cardBrands: [
            {
                name: "Visa",
                small: Images.visaSmall,
                little: Images.visaLittle,
            },
            {
                name: "Mastercard",
                small: Images.mastercardSmall,
                little: Images.mastercardLittle,
            },
            {
                name: "Maestro",
                small: Images.master1,
                little: Images.masterLittle,
            },
            {
                name: "Diners",
                small: Images.dinersSmall,
                little: Images.dinersLittle,
            },
            {
                name: "IRIS",
                small: Images.iris,
                little: Images.iris,
            },
        ],
    },
    // {
    //     value: "iris",
    //     label: "IRIS",
    //     extra: null,
    //     cardBrands: [
    //         {
    //             name: "IRIS",
    //             small: Images.iris,
    //             little: Images.iris,
    //         },
    //     ],
    // },
];

const CARD_INFO_TITLE =
    "Επιλέξτε πληρωμή μέσω Τράπεζας Πειραιώς (Piraeus ePos Pay Center)";

const CARD_INFO_LINES = [
    "Θα μεταφερθείτε στο ασφαλές περιβάλλον πληρωμών του Piraeus ePos Pay Center.",
    "Ολοκληρώστε την πληρωμή και επιστρέψτε στη σελίδα ολοκλήρωσης της παραγγελίας.",
];

export default function PaymentMethodSection({ t, formik }) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const selected = formik.values.paymentMethod;

    const handleChange = (event) => {
        formik.setFieldValue("paymentMethod", event.target.value);
    };

    const radioSx = {
        "& .MuiSvgIcon-root": { fontSize: 20 },
        color: "#8D8D8D",
        "&.Mui-checked": { color: "#111111" },
        p: 0,
        mr: 1,
    };

    return (
        <Box>
            <Typography
                sx={{
                    fontFamily: "'Zen Maru Gothic', sans-serif",
                    fontWeight: 900,
                    fontSize: 24,
                    lineHeight: "110%",
                    textTransform: "uppercase",
                    mb: 2,
                    color: "#111111",
                }}
            >
                {t("Payment way")}
            </Typography>

            <RadioGroup
                name="paymentMethod"
                value={selected}
                onChange={handleChange}
            >
                <Stack spacing={1}>
                    {paymentMethods.map((method) => {
                        const isCard = method.value === "card";
                        const isSelected = selected === method.value;

                        return (
                            <Paper
                                key={method.value}
                                sx={{
                                    p: 2,
                                    borderRadius: "10px",
                                    backgroundColor: "#E9E9E9",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1.5,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", sm: "row" },
                                        alignItems: { xs: "flex-start", sm: "center" },
                                        justifyContent: {
                                            xs: "flex-start",
                                            sm: "space-between",
                                        },
                                        gap: { xs: 1, sm: 2 },
                                    }}
                                >
                                    <FormControlLabel
                                        value={method.value}
                                        control={<Radio sx={radioSx} />}
                                        sx={{ flex: 1, m: 0 }}
                                        label={
                                            <Box sx={{ display: "flex", gap: 1 }}>
                                                <Typography
                                                    sx={{
                                                        fontFamily:
                                                            "'Zen Maru Gothic', sans-serif",
                                                        fontSize: 16,
                                                        color: "#101010",
                                                    }}
                                                >
                                                    {method.label}
                                                </Typography>

                                                {method.extra && (
                                                    <Typography
                                                        sx={{
                                                            fontFamily:
                                                                "'Zen Maru Gothic', sans-serif",
                                                            fontSize: 14,
                                                            fontWeight: 600,
                                                            mt: 0.3,
                                                        }}
                                                    >
                                                        {method.extra}
                                                    </Typography>
                                                )}
                                            </Box>
                                        }
                                    />

                                    {method.cardBrands &&
                                        method.cardBrands.length > 0 && (
                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                sx={{
                                                    flexShrink: 0,
                                                    flexWrap: "wrap",
                                                    alignItems: "center",
                                                    mt: { xs: 1, sm: 0 },
                                                    ml: { xs: 1, sm: 0 },
                                                }}
                                            >
                                                {method.cardBrands.map((brand) => (
                                                    <Box
                                                        key={brand.name}
                                                        component="img"
                                                        src={
                                                            isSmallScreen
                                                                ? brand.little
                                                                : brand.small
                                                        }
                                                        alt={brand.name}
                                                        sx={{
                                                            height: isSmallScreen ? 18 : 24,
                                                            width: "auto",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                ))}
                                            </Stack>
                                        )}
                                </Box>

                                {isCard && isSelected && (
                                    <Box
                                        sx={{
                                            mt: 0.5,
                                            bgcolor: "#F0F0F0",
                                            borderRadius: "5px",
                                            p: 2,
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 1,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontFamily:
                                                    "'Zen Maru Gothic', sans-serif",
                                                fontSize: 16,
                                                color: "#111111",
                                            }}
                                        >
                                            {CARD_INFO_TITLE}
                                        </Typography>

                                        <Box>
                                            {CARD_INFO_LINES.map((line, index) => (
                                                <Typography
                                                    key={index}
                                                    sx={{
                                                        fontFamily:
                                                            "'Zen Maru Gothic', sans-serif",
                                                        fontSize: 14,
                                                        color: "#111111",
                                                    }}
                                                >
                                                    • {line}
                                                </Typography>
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                            </Paper>
                        );
                    })}
                </Stack>
            </RadioGroup>

            {formik.touched.paymentMethod && formik.errors.paymentMethod && (
                <Typography
                    sx={{
                        mt: 1,
                        fontSize: 12,
                        color: "error.main",
                    }}
                >
                    {formik.errors.paymentMethod}
                </Typography>
            )}
        </Box>
    );
}